import { is } from 'ramda'

// data structure: { version: int | undefined, plans: Array<{ id: string, price: string }> }

export default function (plans) {
  return this.sendEventWithCallback('subscription.plans', { api_plans: plans })
    .then(data => {
      // shortcut
      if (is(Array, data.plans)) {
        return data
      }

      return Promise.reject(
        new Error(this.ERROR_UNKNOWN)
      )
    })
}
